import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

const TIMELINE_MAX_HEIGHT = 500

export const useStyles = makeStyles()(() => ({
  scrollWrap: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    minHeight: 0,
  },
  timeline: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    width: '100%',
    maxHeight: TIMELINE_MAX_HEIGHT,
    overflowY: 'auto',
  },
  event: {
    display: 'flex',
    gap: 12,
    alignItems: 'stretch',
    width: '100%',
  },
  rail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    width: 8,
    paddingTop: 6,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
  },
  dotSuccess: {
    backgroundColor: C.successText,
  },
  dotFailure: {
    backgroundColor: C.dangerDot,
  },
  line: {
    flex: '1 0 0',
    minHeight: 8,
    width: 1,
    backgroundColor: C.timelineLine,
  },
  content: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingBottom: 12,
  },
  summary: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
  },
  actor: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.mutedText,
  },
  time: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: C.mutedText,
    whiteSpace: 'nowrap',
  },
  review: {
    display: 'flex',
  },
  empty: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.mutedText,
    margin: 0,
  },
}))
